import classnames from 'classnames';
import * as React from 'react';
import { observer } from 'mobx-react';

import { IViewMore } from 'src/core/components/view-more';
import { RoundArrow } from '../../round-arrow/round-arrow';
import { PresentationSettingsState } from '../../../stores/estimate.store';
import { Estimate } from 'src/api';
import styles from './estimate-summary.less';

interface Props {
    viewMore: IViewMore;
    // The following 2 fields are only used by mobile.
    shouldShowApplyForFinancing: boolean;
    financingPresentationSetting?: PresentationSettingsState | undefined;
    estimate: Estimate;
    gotoMobile: () => void;
}

export const EstimateSummary = observer<React.SFC<Props>>(
    ({ viewMore: { currentHtml, isExpanded, toggleExpanded, showViewMore, setTextDiv } }) => (
        <div className="estimates-summary-fill pt-4 pb-1">
            <div className={classnames('card', styles.summary, { [styles.expanded]: isExpanded })}>
                <h3>Summary</h3>
                <div
                    className={styles.text}
                    dangerouslySetInnerHTML={{ __html: currentHtml }}
                    ref={setTextDiv}
                ></div>
                <RoundArrow
                    className={styles.viewMore}
                    onClick={toggleExpanded}
                    direction={isExpanded ? 'up' : 'down'}
                    hidden={!showViewMore}
                />
            </div>
        </div>
    )
);
